import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useRecoilValue } from "recoil";

import { tokenState } from "store/store";

const useClearQueryOnLogout = () => {
  const token = useRecoilValue(tokenState);

  const queryClient = useQueryClient();

  useEffect(() => {
    if (!token) {
      queryClient.clear();
    }
  }, [token]);
};

export default useClearQueryOnLogout;
